

















import { Component, Prop, Vue } from 'vue-property-decorator';

interface RowItem {
  id: number;
  [key: string]: any;
}

@Component
export default class ScrollBoard extends Vue {
  @Prop({ type: Array, required: true }) readonly data!: any[];
  @Prop({ type: Number, required: true }) readonly height!: number;
  @Prop({ type: Number, default: 0 }) readonly freeze!: number;
  @Prop({ type: Number, default: 3000 }) readonly playInterval!: number;

  viewList: RowItem[] = [];
  rowH: number = 42;
  index: number = 0;
  timer: number | null = null;

  mounted() {
    const count = Math.floor(this.height / this.rowH);

    this.index = count - 1;

    this.viewList = this.data.slice(0, count - 1).map((e, i) => {
      return { ...e, id: i };
    });

    console.log('%c [ this.viewList ]-44', 'font-size:13px; background:pink; color:#bf2c9f;', this.viewList);

    this.timer = window.setInterval(this.dataToView, this.playInterval);
  }

  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }

  dataToView() {
    this.index++;
    if (this.index >= this.data.length) this.index = 0;
    this.viewList.splice(this.freeze || 0, 1);
    this.viewList.push({ id: this.index, ...this.data[this.index] });
  }

  mousemove() {
    if (this.timer) clearInterval(this.timer);
  }

  mouseout() {
    this.timer = window.setInterval(this.dataToView, this.playInterval);
  }

  open(href?: string) {
    if (href) window.open(href);
  }
}
